import { debounce as lodashDebounce } from "lodash-es";

export const debounce = (func: () => void, delay: number) => {
  return delay > 0 ? lodashDebounce(func, delay) : func;
};

export const leadingOnlyThrottle = (func: () => void, delay: number) => {
  let isThrottled = false;

  const release = debounce(() => {
    isThrottled = false;
  }, delay);

  return () => {
    if (isThrottled) {
      return;
    }

    isThrottled = true;

    func();
    release();
  };
};

export const trailingOnlyThrottle = (func: () => void, delay: number) => {
  let isThrottled = false;

  const release = debounce(() => {
    func();

    isThrottled = false;
  }, delay);

  return () => {
    if (isThrottled) {
      return;
    }

    isThrottled = true;

    release();
  };
};
